import React, { createContext } from 'react';
import ReactDOM from 'react-dom';
import './index.scss'
import './style.scss'
import "./_media.scss"
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { Provider } from 'react-redux';
import { store } from './app/store';


const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID
}
export const app = initializeApp(firebaseConfig)
type ContextType = {
  auth: typeof auth
  firestore: typeof firestore
}
const auth = getAuth()
const firestore = getFirestore()

export const Context = createContext(null as unknown as ContextType)
ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter>
      <Context.Provider value={{
        auth,
        firestore,
      }}>
        <React.StrictMode>
          <App />
        </React.StrictMode>
      </Context.Provider>
    </BrowserRouter>
  </Provider>
  ,
  document.getElementById('root')
)
